<form [formGroup]="form">
  <ngx-stripe-card-group [formGroup]="form" [elementsOptions]="elementsOptions">
    <h1>Input payment details to start free trial</h1>
    <div class="payment-detail">
      <app-input
        placeholder="Card Name"
        type="text"
        label="Name on card"
        [control]="form.get('name_on_card')"
        [errorMessage]="getErrorMessage('name_on_card')"
      ></app-input>
      <div
        class="form-group"
        [formGroup]="form"
        ngxStripeCardGroup
        [elementsOptions]="elementsOptions"
      >
        <label class="label">Card number*</label>
        <ngx-stripe-card-number
          [options]="cardOptions"
          (change)="onChange($event, 'cardNumber')"
        ></ngx-stripe-card-number>
        <div id="card-number-errors" class="error-message card"></div>
        <!-- <div class="card-error" id="card-number-errors"></div> -->
        <div class="d-flex justify-content-between">
          <div class="w-50">
            <label class="label">Expiry Date*</label>
            <ngx-stripe-card-expiry
              [options]="cardOptions"
              (change)="onChange($event, 'cardExpiry')"
            ></ngx-stripe-card-expiry>
            <div class="card-error" id="card-expiry-errors"></div>
          </div>
          <div class="w-50">
            <label class="label">CVC*</label>
            <ngx-stripe-card-cvc
              [options]="cardOptions"
              (change)="onChange($event, 'cardCvc')"
            ></ngx-stripe-card-cvc>
            <div class="card-error" id="card-cvc-errors"></div>
          </div>
        </div>
      </div>
      <app-input
        placeholder="Address Line 1"
        type="text"
        label="Address line 1"
        [control]="form.get('address1')"
        [errorMessage]="getErrorMessage('address1')"
        class="w-50"
      ></app-input>
      <app-input
        placeholder="Address Line 2"
        type="text"
        label="Address line 2"
        [control]="form.get('address2')"
        [errorMessage]="getErrorMessage('address2')"
        class="w-50"
      ></app-input>

      <app-input
        placeholder="City"
        type="text"
        label="City"
        [control]="form.get('city')"
        [errorMessage]="getErrorMessage('city')"
        class="w-50"
      ></app-input>
      <app-input
        placeholder="Postcode"
        type="text"
        label="Postcode"
        [control]="form.get('postcode')"
        [errorMessage]="getErrorMessage('postcode')"
        class="w-50"
      ></app-input>
    </div>

    <button
      mat-flat-button
      class="primary-btn"
      matStepperNext
      disabled="{{
        !form.valid || !cardNumberValid || !cardExpiryValid || !cardCvcValid
      }}"
      (click)="onButtonClick()"
    >
      Start 14 days free trial
    </button>
  </ngx-stripe-card-group>
  <div class="d-flex justify-content-center link-block">
    Already have an account?
    <span routerLink="/login" class="link-primary">Login</span>
  </div>
</form>
